/* Pago con tarjeta (Recurrente) vía Odoo desde el carrito local.
   Contrato: docs/CONTRATO.md. Se activa solo si el setting del tema odoo_base_url tiene una URL https válida.
   Carga después de shop.js y antes de site.js: aplica los precios de Odoo (o la copia guardada) al catálogo antes de pintar. */
(()=>{'use strict';
const T=window.BoltTheme||{},O=window.BoltOdoo,B=window.BoltCommerce,S=window.BoltShop,C=window.BoltCatalog;
if(!O||!B||!S||!C)return;
const $=s=>document.querySelector(s),$$=s=>[...document.querySelectorAll(s)],money=B.money;
const BASE=O.baseUrl(T.odooBase);
const CACHE='bolt-precios-v1',TTL=5*60*1000,ENTREGA='bolt-entrega-v1';
const el=(tag,cls,text)=>{const e=document.createElement(tag);if(cls)e.className=cls;if(text!=null)e.textContent=text;return e;};
const track=(ev,data,opts)=>{try{if(typeof window.fbq==='function')window.fbq('track',ev,data,opts);}catch{}};
const ls={get:k=>{try{return localStorage.getItem(k);}catch{return null;}},set:(k,v)=>{try{localStorage.setItem(k,v);}catch{}}};
const ss={get:k=>{try{return sessionStorage.getItem(k);}catch{return null;}},set:(k,v)=>{try{sessionStorage.setItem(k,v);}catch{}}};

/* ---------- Meta: fbclid al aterrizar y datos para la Conversions API ---------- */
const FBCLID='bolt-fbclid';
if(T.pixelId){try{const c=new URLSearchParams(location.search).get('fbclid');if(c&&/^[\w-]{5,300}$/.test(c))ls.set(FBCLID,JSON.stringify({v:c,t:Date.now()}));}catch{}}
function metaActual(){
  let f={};try{f=JSON.parse(ls.get(FBCLID)||'null')||{};}catch{}
  let cookies='';try{cookies=document.cookie;}catch{}
  return O.armarMeta({pixel:!!T.pixelId,cookies,fbclid:f.v,fbclidTs:f.t,href:location.href});
}
/* ---------- Precios de Odoo ---------- */
const r2=n=>Math.round(n*100)/100;
function firmaPrecios(t){return JSON.stringify([t.unit,t.combo,t.regular]);}
function catalogoDifiere(t){
  for(const p of C.PRODUCTOS){const sku=O.SKU[p.id],u=t.unit[sku];if(u&&(p.unidad!==u[1]||p.total2!==r2(u[2]*2)||p.total3!==r2(u[3]*3)||(t.regular[sku]&&p.normal!==t.regular[sku])))return true;}
  for(const c of C.COMBOS){const sku=O.COMBO[c.id==='musculo'?'whey':c.id==='definicion'?'fit':'gainer'];if(t.combo[sku]>0&&c.oferta!==t.combo[sku])return true;}
  return false;
}
let aplicadaAlCargar=null;
function aplicar(t){O.setTabla(t);O.aplicarCatalogo(C,t);}
if(BASE){
  try{const c=JSON.parse(ls.get(CACHE)||'null');const t=c&&O.normalizarPrecios(c.data);if(t){aplicar(t);aplicadaAlCargar=firmaPrecios(t);}}catch{}
}
function pintarPrecios(){
  /* Precios escritos a mano en las tarjetas: Desde Q… y precio de combos */
  $$('.card-body [data-quick-product]').forEach(b=>{const p=C.productoPorId(b.dataset.quickProduct),n=b.closest('.card-body')?.querySelector('p b');if(p&&n)n.textContent=money(p.unidad);});
  $$('.card-body .card-price').forEach(box=>{const b=box.parentElement.querySelector('[data-quick-combo]');if(!b)return;const c=C.COMBOS.find(x=>x.id===b.dataset.quickCombo);if(!c)return;const [pr,del,save]=[box.querySelector('b'),box.querySelector('del'),box.querySelector('span')];if(pr)pr.textContent=money(c.oferta);if(del)del.textContent=money(c.normal);if(save)save.textContent='Ahorrás '+money(c.normal-c.oferta);});
}
async function cargarPrecios(forzar){
  if(!BASE)return null;
  if(!forzar){try{const c=JSON.parse(ls.get(CACHE)||'null');if(c&&Date.now()-c.t<TTL)return O.getTabla();}catch{}}
  const ctl=typeof AbortController==='function'?new AbortController():null,timer=setTimeout(()=>ctl&&ctl.abort(),6000);
  try{
    const res=await fetch(BASE+'/bolt/precios',{headers:{Accept:'application/json'},credentials:'omit',signal:ctl?ctl.signal:undefined});
    if(!res.ok)throw new Error('precios '+res.status);
    const json=await res.json(),t=O.normalizarPrecios(json);if(!t)throw new Error('precios inválidos');
    ls.set(CACHE,JSON.stringify({t:Date.now(),data:json}));
    const cambio=catalogoDifiere(t)||firmaPrecios(t)!==aplicadaAlCargar;
    const yaPintado=catalogoDifiere(t);
    aplicar(t);pintarPrecios();S.render();
    /* La página ya se pintó con precios viejos: se recarga una sola vez por juego de precios, salvo que haya un diálogo abierto */
    if(yaPintado&&cambio&&!$$('dialog').some(d=>d.open)&&ss.get('bolt-precios-recarga')!==firmaPrecios(t)){ss.set('bolt-precios-recarga',firmaPrecios(t));location.reload();}
    return t;
  }catch{return null;/* sin precios de Odoo: se muestran los locales; el servidor recalcula al pagar */}
  finally{clearTimeout(timer);}
}

/* ---------- Interfaz del carrito ---------- */
const MOTIVOS={
  suscripcion:'Las suscripciones se terminan por WhatsApp. El pago con tarjeta es para compra única.',
  anual:'El paquete anual se termina por WhatsApp. El pago con tarjeta es para compra única.',
  cantidad:'Para más de '+O.MAX_LINEA+' unidades de un mismo producto, terminá tu pedido por WhatsApp.',
  sku:'Alguno de los productos no se puede pagar con tarjeta todavía. Terminá tu pedido por WhatsApp.'
};
let waOriginal=null,totalServidor=null;/* totalServidor: {firma,total} tras un precio_cambio */
const main=()=>$('#cart-main-action');
function lineasActuales(){const r=O.lineasContrato(S.lines());return r.ok?r.lineas:[];}
function totalVisto(){const q=S.quote(S.lines()),f=O.firma(lineasActuales());return totalServidor&&totalServidor.firma===f?totalServidor.total:q.payable;}
function refrescar(){
  const m=main(),cart=S.lines();if(!m)return;
  if(!waOriginal)waOriginal=S.mainAction();
  let nota=$('#pago-nota');if(!nota){nota=el('p','fine');nota.id='pago-nota';const a=$('.cart-actions');a.parentNode.insertBefore(nota,a);}
  const demo=$('.cart-demo');if(demo)demo.textContent='Pagá con tarjeta o cuotas, o coordiná tu pedido por WhatsApp.';
  const e=O.elegibilidad(cart);
  if(e.ok){
    m.textContent='Pagar con tarjeta';m.onclick=abrirEntrega;m.disabled=false;
    nota.textContent='Tarjeta o cuotas, en el sitio seguro de Recurrente. También podés terminar tu pedido por WhatsApp.';
  }else{
    m.onclick=waOriginal;
    nota.textContent=e.motivo==='vacio'?'':(MOTIVOS[e.motivo]||'');
  }
}
if(BASE)window.addEventListener('bolt:cart-render',refrescar);

/* ---------- Paso: Datos de entrega ---------- */
const CAMPOS=[
  ['nombre','Nombre completo','input',{autocomplete:'name'}],
  ['telefono','Teléfono (8 dígitos)','input',{type:'tel',inputmode:'numeric',autocomplete:'tel-national',maxlength:'14',placeholder:'5555 1234'}],
  ['email','Correo electrónico','input',{type:'email',autocomplete:'email',placeholder:'tu@correo.com'}],
  ['nit','NIT (opcional)','input',{autocomplete:'off',placeholder:'CF',maxlength:'16'}],
  ['departamento','Departamento','select',{autocomplete:'address-level1'}],
  ['municipio','Municipio','input',{autocomplete:'address-level2'}],
  ['direccion','Dirección de entrega','input',{autocomplete:'street-address',placeholder:'Calle, zona, casa o edificio'}],
  ['referencias','Referencias (opcional)','textarea',{maxlength:'300',rows:'2',placeholder:'Color del portón, punto de referencia, horario'}]
];
function montarEntrega(){
  const cp=$('#checkout-preview');if(!cp||cp.dataset.pago)return;cp.dataset.pago='1';
  const back=$('#back-to-cart'),summary=$('#checkout-summary');
  const kicker=el('p','checkout-kicker','COMPRA SIN CREAR CUENTA'),h=el('h3','','Datos de entrega');
  back.after(kicker,h);
  const form=el('form','checkout-fields');form.id='pago-form';form.noValidate=true;form.autocomplete='on';
  for(const [nombre,etiqueta,tag,attrs] of CAMPOS){
    const label=el('label');label.append(document.createTextNode(etiqueta));
    const inp=document.createElement(tag);inp.name=nombre;inp.id='pago-'+nombre;
    if(tag==='select'){inp.append(new Option('Elegí tu departamento',''));for(const d of O.DEPARTAMENTOS)inp.append(new Option(d,d));}
    for(const [k,v] of Object.entries(attrs))inp.setAttribute(k,v);
    const err=el('span','pago-error');err.id='pago-err-'+nombre;inp.setAttribute('aria-describedby',err.id);
    label.append(inp,err);form.append(label);
  }
  /* honeypot: los bots lo llenan, las personas no lo ven */
  const hp=el('div','pago-hp');hp.setAttribute('aria-hidden','true');const hpl=el('label','','Deja este campo vacío');const hpi=document.createElement('input');hpi.name='hp';hpi.id='pago-hp';hpi.tabIndex=-1;hpi.autocomplete='off';hpl.append(hpi);hp.append(hpl);form.append(hp);
  const estado=el('p','pago-estado');estado.id='pago-estado';estado.setAttribute('role','alert');
  const enviar=el('button','btn cart-primary','Pagar con tarjeta');enviar.type='submit';enviar.id='pago-enviar';
  const nota=el('p','fine','Pagás en el sitio seguro de Recurrente, con tarjeta o en cuotas. Usamos tus datos solo para entregar tu pedido y emitir tu factura. Envío gratis.');
  const wa=el('a','btn wa-order');wa.id='pago-wa';wa.hidden=true;wa.textContent='Mejor termino mi pedido por WhatsApp';
  form.append(estado,enviar,nota,wa);cp.append(form);
  form.addEventListener('submit',pagar);
  form.addEventListener('input',()=>{guardarEntrega();});
  restaurarEntrega();
  cp._summary=summary;
}
function valores(){const o={};for(const [n] of CAMPOS)o[n]=$('#pago-'+n).value;return o;}
function guardarEntrega(){ss.set(ENTREGA,JSON.stringify(valores()));}
function restaurarEntrega(){try{const v=JSON.parse(ss.get(ENTREGA)||'null');if(v)for(const [n] of CAMPOS)if(typeof v[n]==='string')$('#pago-'+n).value=v[n];}catch{}}
function pintarResumen(){
  const cart=S.lines(),host=$('#checkout-summary');
  host.replaceChildren(...cart.map(l=>el('p','',l.qty+' × '+l.title+' · '+l.flavor)),el('p','','Envío gratis'),el('strong','','Total '+money(totalVisto())));
  const b=$('#pago-enviar');if(b&&!b.disabled)b.textContent='Pagar '+money(totalVisto())+' con tarjeta';
}
function estado(msg,waLink){
  const e=$('#pago-estado');e.textContent=msg||'';e.hidden=!msg;
  const w=$('#pago-wa');w.hidden=!waLink;if(waLink)w.href=B.wa(S.lines());
}
function abrirEntrega(){
  const cart=S.lines(),e=O.elegibilidad(cart);if(!e.ok){refrescar();return;}
  montarEntrega();estado('');
  $('#cart-review').hidden=true;$('#checkout-preview').hidden=false;$('#cart-title').textContent='Datos de entrega';
  pintarResumen();
  const q=S.quote(cart),ids=lineasActuales().map(x=>x.sku);
  track('InitiateCheckout',{value:totalVisto(),currency:'GTQ',num_items:q.unidades,content_ids:ids,content_type:'product'});
  const first=$('#pago-nombre');if(first&&!first.value)try{first.focus({preventScroll:true});}catch{}
}

/* ---------- Envío del pedido ---------- */
let enviando=false;
function marcarErrores(errores){
  let primero=null;
  for(const [n] of CAMPOS){const inp=$('#pago-'+n),msg=$('#pago-err-'+n),m=errores[n]||'';msg.textContent=m;inp.setAttribute('aria-invalid',m?'true':'false');if(m&&!primero)primero=inp;}
  if(primero)try{primero.focus();}catch{}
}
async function pagar(ev){
  if(ev&&ev.preventDefault)ev.preventDefault();
  if(enviando)return;
  const cart=S.lines(),e=O.elegibilidad(cart);
  if(!e.ok){estado(MOTIVOS[e.motivo]||'Este carrito no se puede pagar con tarjeta.',true);return;}
  const v=O.validarCliente(valores());marcarErrores(v.errores);
  if(!v.ok){estado('Revisá los datos marcados.');return;}
  const lineas=O.lineasContrato(cart).lineas,visto=totalVisto();
  const cuerpo=O.armarPedido({carritoId:O.carritoId({getItem:ls.get,setItem:ls.set},lineas),lineas,cliente:v.cliente,totalVisto:visto,hp:$('#pago-hp').value,meta:metaActual()});
  enviando=true;const btn=$('#pago-enviar');btn.disabled=true;btn.textContent='Preparando tu pago…';estado('');
  const ctl=typeof AbortController==='function'?new AbortController():null,timer=setTimeout(()=>ctl&&ctl.abort(),25000);
  let res=null,data=null;
  try{
    res=await fetch(BASE+'/bolt/checkout',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(cuerpo),credentials:'omit',signal:ctl?ctl.signal:undefined});
    try{data=await res.json();}catch{data=null;}
  }catch{res=null;}
  clearTimeout(timer);
  enviando=false;btn.disabled=false;
  if(res&&res.ok&&data&&data.ok&&O.urlPagoValida(data.checkout_url,BASE)){
    btn.textContent='Redirigiendo a Recurrente…';btn.disabled=true;
    location.assign(data.checkout_url);return;
  }
  pintarResumen();
  if(!res){estado('No pudimos conectar con el pago. Revisá tu conexión e intentá de nuevo, o terminá tu pedido por WhatsApp.',true);return;}
  const codigo=data&&data.error,msg=data&&typeof data.mensaje==='string'&&data.mensaje;
  if(codigo==='precio_cambio'){
    const nuevo=Number(data.total);
    if(nuevo>0)totalServidor={firma:O.firma(lineas),total:nuevo};
    await cargarPrecios(true);S.render();pintarResumen();
    estado((msg||'Los precios se actualizaron.')+' El total ahora es '+money(totalVisto())+'. Revisalo y tocá Pagar de nuevo.');return;
  }
  if(codigo==='datos_cliente'){estado(msg||'Revisá tus datos de entrega.');return;}
  if(codigo==='demasiadas_solicitudes'){estado(msg||'Hiciste varios intentos seguidos. Esperá un momento e intentá de nuevo.');return;}
  if(codigo==='sku_invalido'||codigo==='cantidad_invalida'||codigo==='no_disponible'){estado((msg||'Alguno de los productos no está disponible para pago en línea.')+' Podés terminar tu pedido por WhatsApp.',true);return;}
  estado('No pudimos preparar tu pago. Intentá de nuevo en unos minutos o terminá tu pedido por WhatsApp.',true);
}

/* ---------- Meta Pixel: AddToCart ---------- */
let previo=new Map(S.lines().map(l=>[l.id,l.qty])),previoTotal=S.quote(S.lines()).payable;
window.addEventListener('bolt:cart',()=>{
  const cart=S.lines(),q=S.quote(cart),agregados=cart.filter(l=>l.qty>(previo.get(l.id)||0));
  if(agregados.length){
    const r=O.lineasContrato(agregados);
    track('AddToCart',{value:Math.max(0,Math.round((q.payable-previoTotal)*100)/100),currency:'GTQ',content_type:'product',content_ids:r.ok?r.lineas.map(x=>x.sku):agregados.map(l=>l.id),num_items:agregados.reduce((a,l)=>a+l.qty-(previo.get(l.id)||0),0)});
  }
  previo=new Map(cart.map(l=>[l.id,l.qty]));previoTotal=q.payable;
});

/* ---------- Arranque ---------- */
if(BASE){pintarPrecios();cargarPrecios(false);}
window.BoltPago={activo:!!BASE,base:BASE,cargarPrecios,abrirEntrega};
})();
